import { serialize } from '@/@core/libs/serialize/util'
import Http from './http'

export const blockList = (params = '') => Http.get(`/wall-blocks${serialize(params)}`)
export const blockCreate = (params = '') => Http.post('/wall-blocks', params)
export const blockByID = (params = '') => Http.get(`/wall-blocks/${params}`)
export const blockUpdate = (params = '') => Http.put(`/wall-blocks/${params.id}`, params)
export const blockDestroy = (params = '') => Http.delete(`/wall-blocks/${params.id}`)
